import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface Testimonial {
  initials: string;
  name: string;
  location: string;
  text: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
}
export function Testimonials({
  testimonials
}: TestimonialsProps) {
  return <section className="py-16 px-4" data-id="element-257">
      <div className="max-w-6xl mx-auto" data-id="element-258">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-259">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border rounded-2xl p-6 flex flex-col" data-id="element-260">
              <div className="flex items-center space-x-4 mb-4" data-id="element-261">
                <div className="w-12 h-12 rounded-full bg-brand/20 text-brand flex items-center justify-center font-bold text-xl" data-id="element-262">
                  {t.initials}
                </div>
                <div data-id="element-263">
                  <div className="font-bold text-white" data-id="element-264">{t.name}</div>
                  <div className="text-sm text-gray-500" data-id="element-265">{t.location}</div>
                </div>
              </div>
              <div className="flex space-x-1 mb-4" data-id="element-266">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-brand text-brand" data-id="element-267" />)}
              </div>
              <p className="text-gray-300 italic flex-grow" data-id="element-268">"{t.text}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}